/** 学员着色色板：10 个区分度高的颜色（OPT-010，按 clientId 取模稳定同色） */
export const CLIENT_COLOR_PALETTE = ['#3B82F6','#10B981','#F97316','#8B5CF6','#EC4899','#14B8A6','#EF4444','#EAB308','#6366F1','#64748B'] as const

/** 无学员（或学员为空）时的默认课程块颜色 */
export const DEFAULT_EVENT_COLOR = '#3B82F6'

/** 课程块颜色：有学员按 clientId 取模，无学员用默认蓝 */
export function clientColor(clientId: number | null | undefined): string {
  if (clientId == null) return DEFAULT_EVENT_COLOR
  return CLIENT_COLOR_PALETTE[clientId % CLIENT_COLOR_PALETTE.length]!
}
